import { ColorPickerControlPlayground } from "../ColorPickerControlPlayground";
import { FileDropzonePlayground } from "../FileDropzonePlayground";
import { FieldPlayground } from "../FieldPlayground";
import { FormFieldsPlayground } from "../FormFieldsPlayground";
import { InputPlayground } from "../InputPlayground";
import { TextAreaPlayground } from "../TextAreaPlayground";
import { NumberInputsPlayground } from "../NumberInputsPlayground";
import { OTPFieldPlayground } from "../OTPFieldPlayground";
import { SearchFieldsPlayground } from "../SearchFieldsPlayground";
import { TagsInputPlayground } from "../TagsInputPlayground";
import { ToggleableInputPlayground } from "../ToggleableInputPlayground";
import type { PlaygroundComponentEntry } from "../playgroundComponents";

export const formControlsEntries: PlaygroundComponentEntry[] = [
    {
        id: "input",
        label: "Input",
        description:
            "Figma text input: primary/ghost/accent, 28-56px, icon slots, clearable, error and disabled states.",
        group: "ready-components",
        render: () => <InputPlayground />,
    },
    {
        id: "text-area",
        label: "Text area",
        description:
            "Figma multiline text field: 28/32/40px rows, auto-grow or resizable, error, read-only and disabled states.",
        group: "ready-components",
        render: () => <TextAreaPlayground />,
    },
    {
        id: "otp-field",
        label: "OTP field",
        description:
            "Base UI one-time-code boxes: 6 numeric 40px slots, paste and autofill, error, read-only and disabled states.",
        group: "ready-components",
        render: () => <OTPFieldPlayground />,
    },
    {
        id: "field",
        label: "Field",
        description:
            "Accessible label, optional marker, tooltip, description, and error shell for form controls.",
        group: "ready-components",
        render: () => <FieldPlayground />,
    },
    {
        id: "form-fields",
        label: "Form fields",
        description:
            "Typed Formik field kit: every kit field in normal, optional, tip, error and disabled states.",
        group: "ready-components",
        render: () => <FormFieldsPlayground />,
    },
    {
        id: "tags-input",
        label: "Tags input",
        description:
            "Chip list input on Base UI: 32/40px, paste splitting, per-value validation, Field-driven error state.",
        group: "ready-components",
        render: () => <TagsInputPlayground />,
    },
    {
        id: "search-fields",
        label: "Search fields",
        description: "Search input with debounced filtering (SearchFilter).",
        group: "components",
        render: () => <SearchFieldsPlayground />,
    },
    {
        id: "number-inputs",
        label: "Number inputs",
        description: "Numeric, monetary, and count inputs with formatting.",
        group: "components",
        render: () => <NumberInputsPlayground />,
    },
    {
        id: "toggleable-input",
        label: "Toggleable input",
        description: "Inline text that switches into an editable input.",
        group: "components",
        render: () => <ToggleableInputPlayground />,
    },
    {
        id: "color-picker-control",
        label: "Color picker",
        description: "Hex color input with swatch.",
        group: "components",
        render: () => <ColorPickerControlPlayground />,
    },
    {
        id: "file-dropzone",
        label: "File dropzone",
        description: "Drag-and-drop file target.",
        group: "components",
        render: () => <FileDropzonePlayground />,
    },
];
